import React from "react";

import Image from "next/image";

import { Box, Card, Typography } from "@mui/material";

import AvatarImage from "../../../public/static/cards/intro-card/avatar.png";

const IntroCard = ({ children, ...props }) => (
  <Card
    sx={{
      alignItems: "flex-end",
      backgroundColor: "primary.main",
      border: "1px #aa9b88 solid",
      borderRadius: 0,
      color: "primary.contrastText",
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      justifyContent: "space-around",
      overflow: "visible",
      position: "relative",
      width: "100%",
      "&::before": {
        content: '""',
        position: "absolute",
        height: "100%",
        width: "100%",
        border: "7px #aa9b88 solid",
      },
      ...props,
      "&::after": {
        content: '""',
        position: "absolute",
        height: "100%",
        width: "100%",
        border: "6px #c9b091 solid",
      },
      ...props,
    }}
  >
    <Box
      sx={{
        px: 2,
        pt: 4,
        pb: { xs: 0, sm: 4 },
        width: { xs: "100%", sm: "50%", md: "40%" },
      }}
    >
      <Typography variant="h6">{children}</Typography>
    </Box>
    <Box
      sx={{
        width: "30%",
      }}
    >
      <Image alt="" src={AvatarImage} layout="responsive" />
    </Box>
  </Card>
);

export default IntroCard;
